import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { WrapPageContext } from "../Layout/ContextWrapper";

import CurrentPlans from "./CurrentPlans";
import ProposedPlans from "./ProposedPlans";

const DistrictPlansBody = ({ data, location }) => {
	const {
		showCurrentDistrictsTab,
		currentDistricts,
		showFinalDistrictsTab,
		finalDistricts,
		showLegislativeProposalsTab,
		legislativeProposals,
		showPublicProposalsTab,
		publicProposals,
	} = data;

	var { forceUpdateToc } = useContext(WrapPageContext);

	const DistrictPlansNavWrapper = styled.nav`
		@media (max-width: 740px) {
			a {
				font-size: 0.85em !important;
			}
		}
	`;

	const tabs = [
		{
			name: "districts-final",
			display: "Final Plans",
			showTab: showFinalDistrictsTab,
			component: <CurrentPlans data={finalDistricts} />,
		},
		{
			name: "districts-proposed",
			display: "Proposed Districts",
			showTab: showLegislativeProposalsTab,
			component: (
				<ProposedPlans
					data={legislativeProposals}
					location={location}
				/>
			),
		},
		{
			name: "districts-2011",
			display: "2011 Districts",
			showTab: showCurrentDistrictsTab,
			component: <CurrentPlans data={currentDistricts} />,
		},
		{
			name: "districts-public",
			display: "Public Proposals",
			showTab: showPublicProposalsTab,
			component: (
				<ProposedPlans data={publicProposals} location={location} />
			),
		},
	];

	const [currentTabIndex, setCurrentTabIndex] = useState(0);

	useEffect(() => {
		const currentTabs = tabs.filter(tab => tab.showTab);

		let locationHashTabIndex = -1;

		if (window.location.hash === "") {
			window.location.hash = `#${currentTabs[0].name}`;
			locationHashTabIndex = tabs
				.map(t => t.name)
				.indexOf(currentTabs[0].name);
		} else {
			locationHashTabIndex = tabs
				.map(t => t.name)
				.indexOf(location.hash.replace("#", ""));
		}

		setCurrentTabIndex(
			locationHashTabIndex === -1 ? 0 : locationHashTabIndex
		);
	}, []);

	const handleTabClick = tabIndex => {
		setCurrentTabIndex(tabIndex);
		forceUpdateToc();
	};

	return (
		<>
			<h1 className="sr-only">District Plans</h1>
			<DistrictPlansNavWrapper aria-label="District plans navigation">
				<ul className="nav nav-tabs">
					{tabs.map((tab, tabIndex) => {
						return tab.showTab ? (
							<li
								className="nav-item"
								key={`district-plans-nav-${tabIndex}`}
							>
								<a
									onClick={() => handleTabClick(tabIndex)}
									className={`nav-link${
										currentTabIndex === tabIndex
											? " active"
											: ""
									}`}
									href={`#${tab.name}`}
								>
									{tab.display}
								</a>
							</li>
						) : null;
					})}
				</ul>
			</DistrictPlansNavWrapper>
			{tabs[currentTabIndex].component}
		</>
	);
};

export default DistrictPlansBody;
